import { isISODateBetween, todayISO } from "./formUtils";

export const isQuestionValid = (question, formData) => {
  const value = formData[question.id];

  // Non-required always valid
  if (!question.required) return true;

  switch (question.fieldType) {
    case "boolean-matrix": {
      // Must have rows defined
      if (!Array.isArray(question.rows) || question.rows.length === 0)
        return true;

      // Value must be an object with an answer for every row
      if (value == null || typeof value !== "object") return false;

      return question.rows.every((r) => {
        const v = value[r.id];
        return v !== undefined && v !== null && String(v) !== "";
      });
    }

    case "range":
      // allow 0; just not null/undefined/""
      return value !== undefined && value !== null && value !== "";
    case "date": {
      if (value === undefined || value === null || String(value) === "")
        return false;
      const MIN = "1900-01-01";
      const MAX = todayISO();
      return isISODateBetween(String(value), MIN, MAX);
    }
    case "radio":
    case "select":
    case "text":
    case "textarea":
    case "number":
    default:
      // generic non-empty check (0 is fine)
      return value !== undefined && value !== null && String(value) !== "";
  }
};
